// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/report/report.css
// module id = 36
// module chunks = 0